import { Logger } from '@west-australian-newspapers/typescript-log'
import React from 'react'
import { StyledTextLink } from '../../user-registration/breach/components/BreachWallContent/BreachWallContent.styled'
import { StyledBenefitsList } from '../RegionalsSwgPromoPage/RegionalsSwgPromoPage.styled'
import { SwgCampaignOfferValues } from '../campaigns'
import { getRrmeOfferPackages } from '../../subscription-offers/SubscriptionOffers'
import { ISingleSubscriptionPackage } from '../../user-registration/breach/helpers/BreachWallTypes'
import { EVERYDAY_DIGITAL } from '../../user-registration/breach/constants'
import { BottomTextWrap, InfoText, InfoTextLink } from '../TextStyles.styled'

export const getDefaultRrmeCampaignValues = (
    log: Logger,
): SwgCampaignOfferValues => {
    const campaignOffers = getRrmeOfferPackages('campaigns', log)
    // We need to check if campaignOffers has the expected key and if it has at least one offer
    // if it doesn't, log a warning as a result of multiple calls and the initial call not having completed yet.
    // The last render will always have at least one offer.
    let swgOffer: ISingleSubscriptionPackage | undefined
    if (
        campaignOffers['default-annual-package'] &&
        campaignOffers['default-annual-package'].length > 0
    ) {
        swgOffer = campaignOffers['default-annual-package'][0] as
            | ISingleSubscriptionPackage
            | undefined
    } else if (
        campaignOffers['default'] &&
        campaignOffers['default'].length > 0
    ) {
        swgOffer = campaignOffers['default'][0] as
            | ISingleSubscriptionPackage
            | undefined
    } else {
        console.warn(
            { campaignOffers },
            'No default or annual-package campaign offers found',
        )
    }
    return {
        isDefault: true,
        creative: 'TW_Subscribe_With_Google_Campaign',
        deal: 'swg-promo',
        type: 'Premium - Inline',
        sku: swgOffer?.googleSKU || '',
        price: {
            weekly: swgOffer?.weeklyPrice || EVERYDAY_DIGITAL,
        },
        BenefitListComponent: (
            <>
                <h3>What's included with your subscription?</h3>
                <StyledBenefitsList>
                    <li>
                        In-depth coverage of sport, business, politics,
                        entertainment and more
                    </li>
                    <li>
                        Access to the daily digital edition of the newspaper,
                        plus all features and lift outs
                    </li>
                    <li>
                        Download{' '}
                        <StyledTextLink
                            reverseColor={false}
                            href={`https://apps.apple.com/au/app/the-west-australian/id1198233691`}
                        >
                            The West App&nbsp;
                        </StyledTextLink>
                        to receive news alerts straight to your device
                    </li>
                </StyledBenefitsList>
            </>
        ),
        TermsAndConditionsComponent: null,
        InfoComponent: (onAllPackagesClicked, productId) => (
            <React.Fragment>
                <BottomTextWrap>
                    <InfoText>
                        Looking for a different subscription?{' '}
                        <InfoTextLink href={'#'} onEvent={onAllPackagesClicked}>
                            Browse all
                        </InfoTextLink>{' '}
                    </InfoText>
                </BottomTextWrap>
                <p>
                    Subscribe today with Google. Now available and making it
                    easier to access{' '}
                    {productId === 'thewest.com.au' ? 'breaking' : 'your local'}{' '}
                    news.
                </p>
            </React.Fragment>
        ),
    }
}
